/**
 * Set the state of a loading component.
 *
 * @param {HTMLElement} loadingEl - The `<.loading>` component to update
 * @param {"loading" | "done" | "error" | "hidden"} state - The state to
 *   set the loading component to.
 */
export function setState(loadingEl, state) {
  const oldState = fetchLoadingState(loadingEl);
  if (oldState === state) return;

  updateLoadingClass(loadingEl, state, oldState);
  updateLoadingHTML(loadingEl, state);
}

function fetchLoadingState(loadingEl) {
  if (loadingEl.classList.contains("loading--loading")) return "loading";
  if (loadingEl.classList.contains("loading--done")) return "success";
  if (loadingEl.classList.contains("loading--error")) return "error";
  if (loadingEl.classList.contains("loading--hidden")) return "hidden";
  throw new Error("Unknown loading state");
}

function updateLoadingClass(loadingEl, state, oldState) {
  const oldStateClass = getStateClass(oldState);
  loadingEl.classList.remove(oldStateClass);

  const newStateClass = getStateClass(state);
  loadingEl.classList.add(newStateClass);
}

function getStateClass(state) {
  switch (state) {
    case "loading":
      return "loading--loading";
    case "done":
      return "loading--done";
    case "error":
      return "loading--error";
    case "hidden":
      return "loading--hidden";
  }
}

function updateLoadingHTML(loadingEl, state) {
  const stateEl = loadingEl.querySelector(".loading__state");
  const stateHTML = getStateHTML(state);
  stateEl.innerHTML = stateHTML;
}

function getStateHTML(state) {
  switch (state) {
    case "loading":
      return `
        <path class="loading__spinner" d="M24,38A12 12 90 0 0 24,10" stroke-linecap="square" />
      `;
    case "done":
      return `
        <circle cx="24" cy="24" r="14" />
        <path d="M18 23L23 28L30 18" stroke-linecap="round" />
      `;
    case "error":
      return `
        <circle cx="24" cy="24" r="14" />
        <line x1="18" y1="24" x2="30" y2="24" stroke-linecap="round" />
      `;
    case "hidden":
      return "";
  }
}
